export const STRING_CONST = {
  doIt: 'DO IT',
  doItRight: 'DO IT RIGHT',
};

export const EMPTY_STRING = '\u200B';
